import { createFileRoute } from "@tanstack/react-router";
import { CampaignsPage } from "@/app/connect/pages/campaigns";

export const Route = createFileRoute("/connect/campaigns")({
	component: CampaignsPage,
});
